<div class="dialog-wrapper">
  <div class="dialog-header">
    <span class="dialog-heading">
      {{ isEdit ? 'Manage folder password' : 'Set folder password' }}
    </span>
    <mat-icon class="close-icon cursor-pointer" (click)="cancel()">close</mat-icon>
  </div>

  <p class="dialog-subtitle">
    {{ isEdit ? 'Change or remove the password for' : 'Set a password to protect' }}
    <strong>{{ data.folderName }}</strong>
  </p>

  <form (ngSubmit)="save()" #form="ngForm">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>{{ isEdit ? 'New password' : 'Password' }}</mat-label>
      <input
        matInput
        [type]="showNew ? 'text' : 'password'"
        [(ngModel)]="newPassword"
        name="newPassword"
        required
        (ngModelChange)="mismatch = false; tooShort = false"
      />
      <mat-icon matSuffix class="cursor-pointer" (click)="showNew = !showNew">
        {{ showNew ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Confirm password</mat-label>
      <input
        matInput
        [type]="showConfirm ? 'text' : 'password'"
        [(ngModel)]="confirmPassword"
        name="confirmPassword"
        required
        (ngModelChange)="mismatch = false"
      />
      <mat-icon matSuffix class="cursor-pointer" (click)="showConfirm = !showConfirm">
        {{ showConfirm ? 'visibility_off' : 'visibility' }}
      </mat-icon>
    </mat-form-field>

    <div *ngIf="tooShort" class="error-message">
      <mat-icon class="error-icon">error_outline</mat-icon>
      Password must be at least 4 characters.
    </div>
    <div *ngIf="mismatch" class="error-message">
      <mat-icon class="error-icon">error_outline</mat-icon>
      Passwords do not match.
    </div>

    <div class="button-wrapper">
      <button
        *ngIf="isEdit"
        type="button"
        class="remove-button cursor-pointer"
        (click)="removePassword()"
        [disabled]="isSaving"
      >
        <mat-icon>lock_open</mat-icon>
        Remove password
      </button>
      <span class="spacer"></span>
      <span class="cancel-link cursor-pointer" (click)="cancel()">Cancel</span>
      <button
        type="submit"
        class="primary-button custom-button save-button"
        [disabled]="!newPassword || !confirmPassword || isSaving"
        [class.disabled-button]="!newPassword || !confirmPassword || isSaving"
      >
        <mat-icon *ngIf="!isSaving">lock</mat-icon>
        {{ isSaving ? 'Saving...' : (isEdit ? 'Change password' : 'Set password') }}
      </button>
    </div>
  </form>
</div>
